import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import ResearchFamilyNotificationsDetailShared from 'shell/components/shared/research-notifications/research-family/detail';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface ResearchFamilyNotificationsDetailCivilStatusSharedProps {
  scope?: string;
  isOther?: boolean;
  isMother?: boolean;
  isFather?: boolean;
  items?: BreadcrumbItem[];
}

const ResearchFamilyNotificationsDetailCivilStatusShared = ({
  scope,
  isOther,
  isMother,
  isFather,
  items,
}: ResearchFamilyNotificationsDetailCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = useMemo(() => {
    return params.idCat || undefined;
  }, [params.idCat]);

  const idNotifica = useMemo(() => {
    return params.idNotifica || '';
  }, [params.idNotifica]);

  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope, idCat]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${baseUrl}/visualizza/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  return (
    <Fragment>
      <ResearchFamilyNotificationsDetailShared
        goBackUrl={goBackUrl}
        goBackUrlDetail={goBackUrlDetail}
        items={items}
        isFather={isFather}
        isMother={isMother}
        isOther={isOther}
      />
    </Fragment>
  );
};

ResearchFamilyNotificationsDetailCivilStatusShared.displayName =
  'Research Family Notifications CivilStatusShared component';

export default ResearchFamilyNotificationsDetailCivilStatusShared;
